<template>
  <div class="questionDetail">
    <div class="qd_empty" v-if="loading && answerList?.length === 0">
      <div class="skeleton"></div>
    </div>
    <div v-else>
      <div class="activity-header-container">
        <div
          class="activity-header"
          :style="{
            paddingTop: stateHeight,
            background: bgColor,
          }"
        >
          <van-nav-bar
            :border="false"
            :title="title"
            class="navbar"
            placeholder
          >
            <template #left>
              <div class="left">
                <img
                  class="icon-back"
                  src="../assets/img/activity/icon-back.png"
                  @click="handleBack"
                />
              </div>
            </template>
          </van-nav-bar>
        </div>
      </div>
      <div
        class="con"
        :style="{
          paddingTop: parseInt(stateHeight) + 48 + 'px',
        }"
      >
        <!--问题信息-->
        <div class="qst">
          <div class="qst_title" v-if="questionInfo.description">
            <span class="icon"></span>
            <span class="qst_text">{{ questionInfo.description }}</span>
          </div>
          <div class="qst_people" v-if="questionInfo?.userInfo">
            <img
              class="avatar"
              :src="questionInfo?.userInfo?.userPortrait"
              alt=""
            />
            <span class="name">{{ questionInfo?.userInfo?.userName }}</span>
          </div>
          <div
            class="qst_source"
            v-if="questionInfo.relationType && questionInfo.relationType != 1"
          >
            <span :class="`icon icon${questionInfo.relationType}`"></span>
            <span class="source"
              >该问题来自{{
                questionInfo.relationType == 3
                  ? "职位"
                  : questionInfo.relationType == 2
                  ? "公司"
                  : ""
              }}</span
            >
            <div
              class="source_name comSource"
              v-if="questionInfo.relationType == 2"
            >
              {{ questionInfo?.companyInfo?.companyName }}
            </div>
            <div class="source_name jobSource" v-else>
              <div v-if="questionInfo?.jobInfo?.jobName" class="jobName">
                {{ questionInfo?.jobInfo?.jobName }}
              </div>
              <div
                v-if="questionInfo?.jobInfo?.provideSalaryString"
                class="dot"
              >
                ·
              </div>
              <div
                v-if="questionInfo?.jobInfo?.provideSalaryString"
                class="jobSalary"
              >
                {{ questionInfo?.jobInfo?.provideSalaryString }}
              </div>
            </div>
          </div>
        </div>
        <!--回答列表-->
        <div class="answerlist">
          <div class="total_num">共{{ totalCount }}个回答</div>
          <van-list
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            :error.sync="jobError"
            loading-text="正在加载…"
            error-text="请求失败，点击重新加载"
            @load="getAnswerList"
          >
            <div
              v-show="answerList.length > 0"
              class="answer_item"
              v-for="(item, index) in answerList"
              :key="index"
            >
              <div class="answer_people">
                <img
                  class="avatar"
                  :src="item?.userInfo?.userPortrait"
                  alt=""
                />
                <div class="name">
                  <div class="nameinfo">
                    <span>{{ item?.userInfo?.userName }}</span>
                    <span
                      v-show="item?.userInfo?.userType == 2"
                      class="tag"
                    ></span>
                  </div>
                  <div class="cominfo" v-show="item?.userInfo?.userType == 2">
                    <span>{{ item?.userInfo?.userCoName }}</span>
                    <span
                      v-show="item?.userInfo?.userCoPosition"
                      class="label"
                      >{{ item?.userInfo?.userCoPosition }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="text">{{ item.message }}</div>
              <div class="time">{{ item.createTime }}</div>
              <div
                v-show="index <= answerList.length - 2"
                class="partline"
              ></div>
            </div>
          </van-list>
          <!--暂无回答-->
          <div v-show="!loading && answerList.length == 0" class="noanswer">
            <div class="empty_pic"></div>
            <div class="empty_text">
              {{ questionStatus == "-1" ? "提问被驳回" : "暂无回答" }}
            </div>
          </div>
        </div>
      </div>
      <!---->
      <div class="answer" v-if="isMyThread && questionStatus == '-1'">
        <div class="answer_btn" @click="goAnswer">重新提问</div>
      </div>
      <div class="answer" v-if="!isMyThread">
        <div class="answer_btn" @click="goAnswer">去回答</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionDetail",
  data() {
    return {
      title: "",
      totalCount: 0,
      questionInfo: {}, // 问题详情
      stateHeight: 0,
      bgColor: "",
      answerList: [],
      offsetTop: "",
      pageSize: 10,
      pageNum: 1,
      loading: true,
      finished: false,
      jobError: false,
      questionStatus: 1, //状态
      isMyThread: false, //是否为我的提问
    };
  },
  created() {},
  async mounted() {
    this.offsetTop = this.$base.getAppStateHeight(44);
    this.getAnswerList();
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.bgColor = "linear-gradient( 180deg, #F9EBE1 0%, #F8F2EE 100%)";
      } else {
        this.bgColor = "";
      }
    },
    // 返回
    handleBack() {
      // window.history.go(-1);
      const {
        activityId,
        formPage,
        componentId,
        type,
        jobSource,
        id,
        originType,
      } = this.$route.query;
      const sessionData = sessionStorage.getItem(activityId);
      const { func, city } = sessionData ? JSON.parse(sessionData) : {};
      const queryMap = {
        列表页: {
          id,
          activityId,
          componentId,
          type: originType || type,
          jobSource,
        },
        活动页: {
          func,
          city,
        },
      };
      this.$router.push({
        path:
          formPage === "列表页"
            ? "/questionAndAnswerList"
            : `/op/${activityId}`,
        query: queryMap[formPage],
      });
    },
    getAnswerList() {
      if (this.finished) return;
      let params = {
        questionId: this.$route.query.questionId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      this.$api.activity
        .answerListQuery(params)
        .then((res) => {
          this.loading = false;
          if (res?.code == "0") {
            this.totalCount = res.data.totalCount;
            this.pageNum++;
            this.answerList = [...this.answerList, ...res.data.answerList];
            this.questionInfo = res.data.questionInfo
              ? res.data.questionInfo
              : this.questionInfo;
            this.questionStatus = res.data?.questionInfo?.status;
            this.isMyThread = res.data?.questionInfo?.isMyThread;
            if (this.answerList.length >= this.totalCount) {
              this.finished = true;
            }
            if (this.totalCount <= 10) {
              this.finished = true;
            }
            //帖子详情页曝光
            this.$sensors.track("PostdetailExposure", {
              contentId: this.$route.query.questionId,
              companyId:
                this.questionInfo.relationType == "2"
                  ? this.questionInfo?.companyInfo?.coId
                  : this.questionInfo?.jobInfo?.coId,
              jobId: this.questionInfo?.jobInfo?.jobId,
              contentRank: this.$route.query.index,
              resultNumber: this.totalCount,
            });
            //被驳回问题详情展示埋点
            if (this.isMyThread && this.questionStatus == "-1") {
              this.$sensors.track("WidgetShow", {
                $element_id: "sensor_bcop_qareject",
                contentId: this.$route.query.questionId,
              });
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    goAnswer() {
      const { type, activityId, jobSource, componentId, originType } =
        this.$route.query;
      const extrParams = {
        2: {
          coId: this.questionInfo?.companyInfo?.coId,
          coName: this.questionInfo?.companyInfo?.companyName,
          ctmId: this.questionInfo?.companyInfo?.ctmId,
          jobSource,
        },
        3: {
          jobId: this.questionInfo?.jobInfo?.jobId,
          coId: this.questionInfo?.jobInfo?.coId,
          jobName: this.questionInfo?.jobInfo?.jobName,
          provideSalaryString: this.questionInfo?.jobInfo?.provideSalaryString,
          coName: this.questionInfo?.jobInfo?.companyName,
          ctmId: this.questionInfo?.jobInfo?.ctmId,
        },
      };
      if (this.isMyThread && this.questionStatus == "-1") {
        // 我的提问并且被驳回 重新提问
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_qareject_ask",
          contentId: this.$route.query.questionId,
        });
        this.$router.push({
          path: "/askQuestion",
          query: {
            activityId,
            type,
            originType,
            componentId,
            ...extrParams[type],
          },
        });
      } else {
        // 去回答
        const extr = {
          2: {
            companyId: this.questionInfo?.companyInfo?.coId,
          },
          3: {
            companyId: this.questionInfo?.jobInfo?.coId,
            jobId: this.questionInfo?.jobInfo?.jobId,
          },
        };
        this.$sensors.track("PostdetailClick", {
          contentId: this.$route.query.questionId,
          contentRank: this.$route.query?.index,
          ...extr[type],
        });
        this.$router.push({
          path: "/askQuestion",
          query: {
            isFromQuestionDetail: 1,
            question: this.questionInfo.description,
            questionId: this.$route.query.questionId,
            index: this.$route.query.index,
            activityId,
            type,
            originType,
            componentId,
            ...extrParams[type],
          },
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
* {
  overflow: hidden;
}

.questionDetail {
  background: linear-gradient(
    180deg,
    rgba(255, 117, 29, 0.1) 0%,
    rgba(255, 255, 255, 0) 20%
  );
  position: relative;
  // background: #F8F8F8;
  .qd_empty {
    background-image: url("@/assets/img/activity/question_detail_empty.png") !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    .pc & {
      width: 375px;
      left: 50%;
      transform: translateX(-50%);
    }
    .skeleton {
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 24%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.9) 75%,
        rgba(255, 255, 255, 0) 76%,
        rgba(255, 255, 255, 0) 100%
      );
      background-size: 50% 100%;
      filter: blur(25px);
      animation: gradient 1.5s linear infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      100% {
        background-position: 100% 50%;
      }
    }
  }
  .activity-header-container {
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
      .publish {
        width: 61px;
        height: 24px;
        background: #ff6c0e;
        border-radius: 15px;
        color: #ffffff;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .con {
    padding: 0 8px;
    padding-top: 48px;
    .qst {
      width: 100%;
      // height: 132px;
      background: #ffffff;
      border-radius: 8px;
      padding: 20px 8px 12px 8px;
      .qst_title {
        width: 100%;
        display: flex;
        align-items: baseline;
        .icon {
          width: 16px;
          height: 16px;
          background: url("@/assets/img/activity/question@3x.png");
          background-size: cover;
          margin-right: 8px;
          margin-left: 8px;
        }
        .qst_text {
          font-weight: 600;
          font-size: 18px;
          color: #222222;
          font-style: normal;
          flex: 1;
        }
      }
      .qst_people {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 14px;
        .avatar {
          width: 17px;
          height: 17px;
          border-radius: 50%;
          margin: 0 8px;
          background: pink;
        }
        .name {
          font-weight: 400;
          font-size: 12px;
          color: #222222;
          font-style: normal;
        }
      }
      .qst_source {
        width: 100%;
        height: 34px;
        background: #f4f8fb;
        border-radius: 8px;
        margin-top: 13px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-right: 10px;
        .icon {
          width: 12px;
          height: 12px;
          background: url("@/assets/img/activity/company@3x.png");
          background-size: cover;
          margin: 0 10px;
          &.icon3 {
            width: 12px;
            height: 12px;
            background: url("@/assets/img/activity/job@3x.png");
            background-size: cover;
          }
        }
        .source {
          width: 84px;
          font-weight: 400;
          font-size: 12px;
          color: #4e525a;
          font-style: normal;
          margin-right: 6px;
          white-space: nowrap;
        }
        .source_name {
          font-weight: 600;
          font-size: 12px;
          color: #222222;
          font-style: normal;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 2;
          // overflow: hidden;
          // text-overflow: ellipsis;
          &.comSource {
            text-overflow: ellipsis;
          }
          &.jobSource {
            display: flex;
            align-items: center;
            .dot {
              margin: 0 4px;
            }
            .jobName {
              max-width: 112px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .jobSalary {
              max-width: 84px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
    .answerlist {
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      padding: 12px 14px;
      margin-top: 8px;
      margin-bottom: 115px;
      .total_num {
        font-weight: 500;
        font-size: 14px;
        color: #222222;
        font-style: normal;
      }
      .answer_item {
        width: 100%;
        .answer_people {
          display: flex;
          align-items: center;
          margin-top: 14px;
          .avatar {
            width: 33px;
            height: 33px;
            border-radius: 50%;
            margin-right: 8px;
            background: pink;
          }
          .name {
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            text-align: left;
            font-style: normal;
            .nameinfo {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              .tag {
                width: 26px;
                height: 13px;
                background: url("@/assets/img/activity/HR@3x.png");
                background-size: cover;
                margin-left: 5px;
              }
            }
            .cominfo {
              font-weight: 400;
              font-size: 12px;
              color: #898989;
              // line-height: 16px;
              text-align: left;
              font-style: normal;
              margin-top: 2px;
              .label {
                margin-left: 7px;
              }
            }
          }
        }
        .text {
          width: 100%;
          margin-top: 8px;
          font-weight: 400;
          font-size: 14px;
          color: #222222;
          line-height: 22px;
          text-align: left;
          font-style: normal;
        }
        .time {
          width: 100%;
          font-weight: 400;
          font-size: 12px;
          color: #6e6e6e;
          text-align: left;
          font-style: normal;
          margin-top: 12px;
        }
        .partline {
          width: 100%;
          height: 1px;
          background: #dadada;
          margin-top: 16px;
        }
      }
      .noanswer {
        width: 100%;
        min-height: 70%;
        margin: 90px 0;
        .empty_pic {
          width: 113px;
          height: 90px;
          background: url("@/assets/img/activity/emptyData@2x.png");
          background-size: cover;
          margin: 0 auto;
        }
        .empty_text {
          font-weight: 400;
          font-size: 14px;
          color: #222222;
          text-align: center;
          font-style: normal;
          margin-top: 8px;
        }
      }
    }
  }
  .answer {
    width: 100%;
    height: 107px;
    background: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    .pc & {
      width: 375px;
      left: 50%;
      transform: translateX(-50%);
    }
    .answer_btn {
      width: 343px;
      height: 44px;
      background: #ff6c0e;
      border-radius: 4px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: left;
      font-style: normal;
      text-align: center;
      margin: 0 auto;
      margin-top: 17px;
    }
  }
  /deep/ .van-list__loading {
    margin: 11px 0 27px 0;
    .van-loading--circular {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-loading__circular {
      display: none;
    }
    .van-loading__spinner--circular {
      height: 16px !important;
      display: block;
      width: 14px !important;
    }
    .van-loading__spinner--circular::after {
      content: "";
      background-image: url("~@/assets/img/activity/loading@2x.png");
      background-size: cover;
      height: 16px;
      display: block;
      width: 14px;
      background-repeat: no-repeat;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .van-loading__text {
      font-weight: 400;
      font-size: 13px;
      color: #4e4e4e;
      margin-left: 6px;
    }
  }
  /deep/ .van-list__error-text,
  /deep/ .van-list__finished-text,
  /deep/ .van-list__loading {
    color: #4e4e4e;
    text-align: center;
    margin: 11px 0 0px 0;
  }
}
</style>
